import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class FlightReportEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      show_select_clients: false,
      id: this.props.flight_report_id,
      aircraft_id: this.props.flight_report.aircraft_id,
      base_id: this.props.flight_report.base_id,
      contract_id: this.props.flight_report.contract_id,
      flight_type_id: this.props.flight_report.flight_type_id,
      staff_sigmec_id: this.props.flight_report.staff_sigmec_id,
      client_id: this.props.flight_report.client_id,
      date: this.props.flight_report.date,
      flight_type: this.props.flight_type,
      flight_number: this.props.flight_report.flight_number,
      report_number: this.props.flight_report.report_number,
      exemption: this.props.flight_report.exemption,
      sar_flights: this.props.flight_report.sar_flights,
      power_checks: this.props.flight_report.power_checks,
      night_deck_landing: this.props.flight_report.night_deck_landing,
      observations: this.props.flight_report.observations,
      bases_select: this.props.bases_select,
      aircrafts_select: this.props.aircrafts_select,
      flight_types_select: this.props.flight_types_select,
      contracts_select: this.props.contracts_select,
      clients_select: this.props.clients_select,
      staff_mechanics_select: this.props.staff_mechanics_select,
      daily_flights: this.props.daily_flights,
    };

    //bind específico
    this.edit = this.edit.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, change);
    } else if (name === 'takeoff_time_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
      this.delayTotalTime(this.state.total_time_scheduled, event.target.value, change);
    } else if (name === 'total_time_scheduled') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectFlightTypeChange(name, event) {
    var change = {};
    var self = this;
    change['flight_type_id'] = null;
    change['client_id'] = null;
    change['show_select_clients'] = null;
    if(event == null) {
      change[name] = null;
    } else {

      if(navigator.onLine) {
        self.setState({overlay: {message: '', type: '', status: 'open'}});
        change[name] = event.value;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function(value) {
          var url = config.get('api') + '/tipo/voo/' + event.value;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.data.client_required === 1) {
              self.setState({
                show_select_clients: true,
              });
            }
          }).then(() => {
            self.setState({overlay: {message: '', type: '', status: 'closed'}});
          }); /* Overlay */
        });          
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }      
    }
    this.setState(change);
  }
  handleSelectAircraftChange(name, event) {
    var change = {};
    var self = this;
    change['contract_id'] = null;
    if(event == null) {
      change[name] = null;
    } else {
      self.props.handleAlert('', '', 'open');
      change[name] = event.value;
      var header = self.refs.request_api.header('application/json');

      if(navigator.onLine) {
        
        Promise.resolve(header).then(function(value) {
          var url = config.get('api') + '/contrato/aeronave/select/' + event.value;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'success') {
              self.setState({
                contracts_select: responseJson.data,
              });
            }
          }).then(() => {
            self.props.handleAlert('', '', 'closed');
          }); /* Overlay */
        });
  
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }      
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.date === 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        id: newProps.flight_report_id,
        aircraft_id: newProps.flight_report.aircraft_id,
        base_id: newProps.flight_report.base_id,
        contract_id: newProps.flight_report.contract_id,
        flight_type_id: newProps.flight_report.flight_type_id,
        staff_sigmec_id: newProps.flight_report.staff_sigmec_id,
        client_id: newProps.flight_report.client_id,
        show_select_clients: newProps.flight_type.client_required,
        date: newProps.flight_report.date_str,
        flight_number: newProps.flight_report.flight_number,
        report_number: newProps.flight_report.report_number,
        flight_type: newProps.flight_type,
        exemption: newProps.flight_report.exemption,
        sar_flights: newProps.flight_report.sar_flights,
        power_checks: newProps.flight_report.power_checks,
        night_deck_landing: newProps.flight_report.night_deck_landing,
        observations: newProps.flight_report.observations,
        bases_select: newProps.bases_select,
        aircrafts_select: newProps.aircrafts_select,
        flight_types_select: newProps.flight_types_select,
        contracts_select: newProps.contracts_select,
        clients_select: newProps.clients_select,
        staff_mechanics_select: newProps.staff_mechanics_select,
        daily_flights: newProps.daily_flights,
        loaded: 1,
      });
      if(!newProps.flight_report.flight_number || newProps.flight_report.flight_number === null) {
        this.setState({
          flight_number: '',
        });
      }
    }
  }

  // Fetch salvando a edição
  edit(event) {

    event.preventDefault();
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        staff_sigmec_id: this.state.staff_sigmec_id,
        client_id: this.state.client_id,
        date: this.state.date,
        flight_number: this.state.flight_number,
        report_number: this.state.report_number,
        exemption: this.state.exemption,
        sar_flights: this.state.sar_flights,
        power_checks: this.state.power_checks,
        night_deck_landing: this.state.night_deck_landing,
        observations: this.state.observations,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
  
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }    
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Data}:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" disabled />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Prefixo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectAircraftChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
                disabled
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Voo}:</label>
              <Select
                className="form-field-name"
                name="flight_type_id"
                value={this.state.flight_type_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectFlightTypeChange.bind(this, 'flight_type_id')}
                options={this.state.flight_types_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.NumeroDeVoo}:</label>
              <input type="text" name="flight_number" className="form-control" placeholder="" value={this.state.flight_number} onChange={this.handleChange.bind(this, 'flight_number')} />
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.SolicitouIsencao}</label>
              <br/>
              <Toggle
                checked={this.state.exemption}
                aria-label='No label tag'
                name="exemption"
                onChange={this.handleToggleChange.bind(this, 'exemption')} />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.PowerCheck}</label>
              <br/>
              <Toggle
                checked={this.state.power_checks}
                aria-label='No label tag'
                name="power_checks"
                onChange={this.handleToggleChange.bind(this, 'power_checks')}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Contrato}:</label>
              <Select
                className="form-field-name"
                name="contract_id"
                value={this.state.contract_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'contract_id')}
                options={this.state.contracts_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.NumeroDoRelatorio}:</label>
              <input type="text" name="report_number" className="form-control" placeholder="" value={this.state.report_number} onChange={this.handleChange.bind(this, 'report_number')} required />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.MecanicoResponsavel}:</label>
              <Select
                className="form-field-name"
                name="staff_sigmec_id"
                value={this.state.staff_sigmec_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'staff_sigmec_id')}
                options={this.state.staff_mechanics_select}
              />
          </div>
        </div>
        {(this.state.show_select_clients == true) &&
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Cliente}</label>
              <Select
                className="form-field-name"
                name="client_id"
                value={this.state.client_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'client_id')}
                options={this.state.clients_select}
                required
              />
            </div>
          </div>
        }
        <hr/>
        <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Titulo}</h4>
        <hr/>
        <BootstrapTable data={this.state.daily_flights} pagination={false} striped={true} hover={true} exportCSV={false} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.SemVoos}} search={false} multiColumnSearch={false}  searchPlaceholder={this.locale.general.procurar}>
          <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={false} width='60'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Id}</TableHeaderColumn>
          <TableHeaderColumn dataField="flight_number" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.NumeroVoo}</TableHeaderColumn>
          <TableHeaderColumn dataField="report_number" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.NumeroRelatório}</TableHeaderColumn>
          <TableHeaderColumn dataField="client" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Cliente}</TableHeaderColumn>
          <TableHeaderColumn dataField="contract" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Contrato}</TableHeaderColumn>
          <TableHeaderColumn dataField="flight_type" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.TipoVoo}</TableHeaderColumn>
          <TableHeaderColumn dataField="status" dataAlign="center" dataSort={false} width='120'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Status}</TableHeaderColumn>
        </BootstrapTable>
        <hr/>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.botaoEditarRelatorioDeVoo}</button>
      </form>
</div>
    );
  }
}

export default FlightReportEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportEditTab.js